let Query = require('helper/query');
// let Pagination = require('pokeball/components/pagination')
let PaginationTmpl = Handlebars.templates['common/ajax-template-search/templates/pagination'];

class AjaxTemplateSearch {
  constructor (_config) {
    if (!_config.ajaxUrl) {
      throw new Error('AjaxTemplateSearch组件的ajaxUrl为必填' + JSON.stringify(_config));
    }
    if (!_config.template) {
      throw new Error('AjaxTemplateSearch组件的template为必填，为Handlebars.templates的function');
    }

    let _default = {
      template: null, // 模板，为Handlebars.templates的function
      ajaxUrl: '', // ajax请求地址
      extends: null,
      paginationSelector: '', // 分页组件的位置
      root: '', // 组件的根
      appendElem: '.ajax-template', // 结果append位置
      searchElem: '', // 搜索组件的选择器
      searchBtn: '#searchBtn', // 搜索按钮的选择器
      clearBtn: '#resetBtn', // 清空按钮的选择器
      searchResetParams: [], // 搜索时重置的参数
      resetParams: [], // 重置时的参数
      callback: null
    };

    this.query = new Query();
    this.query.set('pageSize', 15);
    this.query.set('pageNo', 1);
    this.config = $.extend(_default, _config);

    this.bindEvent();

    /* 如果有扩展，填入query */
    if ($.isPlainObject(this.config.extends)) {
      $.each(this.config.extends, (key, value) => {
        this.query.set(key, value);
      });
    }

    this._search(true);
  }

  initTmpl (data) {
    let vm = this;
    $(vm.config.root + ' ' + vm.config.paginationSelector).html(PaginationTmpl(data || {}));
    const count = $(vm.config.root + ' .pagination-total').data('total');
    let sources = (function () {
      let result = [];
      for (let i = 0; i < count; i++) {
        result.push(i);
      }
      return result;
    })();
    let options = {
      dataSource: sources,
      totalNumber: count,
      pageSize: vm.query.get('pageSize'),
      pageNumber: 1,
      prevText: '<',
      nextText: '>',
      showGoInput: true,
      showGoButton: true,
      beforeGoButtonOnClick: (event, pageNumber) => {
        let lastPageNo = $(vm.config.root + ' .paginationjs-last').data('num');
        if (!lastPageNo) {
          lastPageNo = $(vm.config.root + ' .J-paginationjs-page:last').data('num');
        }
        if (pageNumber > lastPageNo) {
          /* eslint-disable */
          alert('跳转页数不得大于最大页数');
          return;
        }
        if (pageNumber >= 1) {
          vm.query.set('pageNo',pageNumber);
          vm._search(false);
        }
      },
      beforePageOnClick: (event, pageNumber) => {
        vm.query.set('pageNo',pageNumber);
        vm._search(false);
      },
      beforeGoInputOnEnter: (event, pageNumber) => {
        let lastPageNo = $(vm.config.root + ' .paginationjs-last').data('num');
        if (!lastPageNo) {
          lastPageNo = $(vm.config.root + ' .J-paginationjs-page:last').data('num');
        }
        if (!/^\d+$/.test(pageNumber) || pageNumber > lastPageNo || pageNumber < 1) {
          alert('跳转页数不合法');
          return;
        }
        vm.query.set('pageNo',pageNumber);
        vm._search(false);
      },
      beforePreviousOnClick: (event, pageNumber) => {
        vm.query.set('pageNo',pageNumber);
        vm._search(false);
      },
      beforeNextOnClick: (event, pageNumber) => {
        vm.query.set('pageNo',pageNumber);
        vm._search(false);
      }
    };
  
    $(vm.config.root + ' .pagination-list').pagination(options);
    // 回填每页条数
    let $itemsPerPageSelector = $(vm.config.root + ' .items-per-page-selector');
    $itemsPerPageSelector.val(vm.query.get('pageSize'));
    // pageSize事件
    $itemsPerPageSelector.off('change').on('change', function (e) {
      vm.query.set('pageNo',1);
      vm.query.set('pageSize', $(e.target).val())
      vm._search(true);
    })
  }

  /**
   * 转成统一格式
   *
   * @param {any} data
   * @returns
   *
   *  {
   *    total: 20,
   *    data: []
   *  }
   */
  transformData(resp) {
    if (!resp) {
      return {}
    }
    // TOFIX: 数据格式归类
    if (resp.entities){
      resp = resp.entities;
    }
    if ($.isArray(resp)) {
      return {
        total: resp.length,
        data: resp
      }
    }
    if (!resp.result) {
      /**
       * {
       *   total:
       *   data:
       * }
       */
      if (resp.data && $.isArray(resp.data)) {
        return {
          total: resp.total,
          data: resp.data
        }
      }
      return {}
    }

    /**
     * {
     *   total:
     *   result:
     * }
     */
    if ($.isArray(resp.result)) {
      return {
        total: resp.total,
        data: resp.result
      }
    }
    /**
     * {
     *   total:
     *   result: {
     *    total:,
     *    data
     *   }
     * }
     */
    if ($.isArray(resp.result.data)) {
      return {
        total: resp.result.total,
        data: resp.result.data
      }
    }
    return {}
  }

  bindEvent() {
    let vm = this
    $(vm.config.searchBtn).unbind('click').bind('click', function () {
      if (vm.config.searchElem) {
        let $elems = $(vm.config.root).find('input' + vm.config.searchElem + '[name],select' + vm.config.searchElem + '[name],textarea' + vm.config.searchElem + '[name]')
        $elems.each(function () {
          let key = $(this).attr('name')
          let value = $(this).val()

          var elementType = $(this).attr('type')
          if (elementType === 'checkbox') {
            value = $(this).prop('checked')
          }

          if (typeof value === 'undefined' || value === null || value === '') {
            vm.query.remove(key)
          } else {
            vm.query.set(key, value)
          }
          for (let i = 0; i < vm.config.searchResetParams.length; i++) {
            vm.query.remove(vm.config.searchResetParams[i])
          }
        })
      }

      vm._search(true)
    })

    $(vm.config.clearBtn).unbind('click').bind('click', function () {
      for (let i = 0; i < vm.config.resetParams.length; i++) {
        vm.query.remove(vm.config.resetParams[i])
        $(vm.config.root).find("input[name='" + vm.config.resetParams[i] + "']").val('')
      }
      vm._search(true)
    })
  }

  _search(refreshPage) {
    let vm = this
    if ($.isFunction(vm.config.extends)) {
      let extendParams = vm.config.extends()
      $.each(extendParams, (key, value) => {
        vm.query.set(key, value)
      })
    }

    $.ajax({
      type: 'GET',
      url: vm.config.ajaxUrl + vm.query.toString(),
      contentType: 'application/json',
      dataType: 'json',
      async: false,
      success: function (resp) {
        let data = vm.transformData(resp)
        /* 将新数据添加到template中 */
        $(vm.config.root + ' ' + vm.config.appendElem).html(vm.config.template(data));
        /* 是否需要分页器 && 重置分页器 */
        if(data.total > vm.query.get('pageSize') && refreshPage ){
          vm.initTmpl(data)
        }
        vm.config.callback && vm.config.callback(data)
      }
    })
  }
}

module.exports = AjaxTemplateSearch
